// Официальные документы РФ (СОР, СОРБ, справка МВД, аттестат, диплом).
// Ключи совпадают с backend/services/civil_documents.py → DOC_TYPES.
// Каждый вид — отдельная плитка при загрузке, как паспорт и ВУ.
import { Baby, HeartCrack, ShieldCheck, School, GraduationCap } from "lucide-react";

// группа для вкладки «Документы РФ» в истории
export const CIVIL_UPLOAD_TYPE = "civil";

export const CIVIL_COLOR = "#8b5cf6";

export const CIVIL_DOC_KINDS = [
  {
    key: "ru_birth_certificate",
    label: "Свидетельство о рождении",
    short: "СОР",
    description: "РФ, бланки 1998 г. и с 2018 г. — перевод по шаблону",
    Icon: Baby,
  },
  {
    key: "ru_divorce_certificate",
    label: "Свидетельство о расторжении брака",
    short: "СОРБ",
    description: "РФ, бланки до 2018 г. и с 2018 г. — перевод по шаблону",
    Icon: HeartCrack,
  },
  {
    key: "ru_criminal_record",
    label: "Справка о несудимости",
    short: "Справка МВД",
    description: "Справка МВД РФ, с апостилем — перевод по шаблону",
    Icon: ShieldCheck,
  },
  {
    key: "ru_school_certificate",
    label: "Аттестат с приложением",
    short: "Аттестат",
    description: "Школьный аттестат РФ и оценки — перевод по шаблону",
    Icon: School,
  },
  {
    key: "ru_diploma",
    label: "Диплом с приложением",
    short: "Диплом",
    description: "Диплом вуза РФ: бакалавр, специалист, магистр",
    Icon: GraduationCap,
  },
];

const BY_KEY = Object.fromEntries(CIVIL_DOC_KINDS.map((k) => [k.key, k]));

export const isCivilDocType = (t) => Boolean(BY_KEY[t]);

// за страницу (тариф × страницы): прочие документы и документы РФ по шаблонам;
// паспорта и права — за документ. Так же считает бэкенд (/api/process).
export const isPagePriced = (t) => t === "contract" || isCivilDocType(t);

// несколько файлов этих типов можно склеить в один документ (лист + оборот +
// апостиль); паспорт и права — каждый файл отдельный документ
export const canMergePages = isPagePriced;

// Диплом и аттестат — это два общих шаблона (документ и приложение). Бюро ждёт
// один файл, как в плитке «Диплом с приложением»: добавляем первым пунктом
// вариант «документ + приложение» с составным id "289+290" (см. handleFillTemplate).
export const withTemplatePair = (list) => {
  const main = list.find((t) => t.isPublic && t.filename && !t.filename.includes("_supplement_"));
  const supp = list.find((t) => t.isPublic && t.filename && t.filename.includes("_supplement_"));
  if (!main || !supp || !isCivilDocType(main.document_type)) return list;
  const pair = {
    id: `${main.id}+${supp.id}`,
    name: `${main.name} + приложение`,
    country: main.country,
    document_type: main.document_type,
    isPair: true,
  };
  return [pair, ...list];
};

export const civilDocShort = (t) => BY_KEY[t]?.short || t;

export const civilDocLabel = (t) => BY_KEY[t]?.label || t;

export const civilDocIcon = (t) => BY_KEY[t]?.Icon;

// Глоссарий (TranslationRule.document_type) общий для всех видов — см. GLOSSARY_DOCUMENT_TYPE
export const CIVIL_GLOSSARY_TYPE = "civil_ru";

// Имя для заголовка карточки документа — из перевода: в оригинале ФИО
// бывают в косвенном падеже («Агеевым»)
export const civilDocTitle = (data) => {
  const main = data?.doc_main_translation || data?.doc_main || {};
  const v = (k) => main[k]?.data || "";
  if (data?.document_type === "ru_divorce_certificate")
    return [v("spouse1_surname"), v("spouse2_surname")].filter(Boolean).join(" / ");
  if (data?.document_type === "ru_criminal_record") return v("full_name");
  return [v("surname"), v("given_names")].filter(Boolean).join(" ");
};
